// All JS and CSS needed on render/preview sm page
/* global $ */

import 'styles/common/Common.scss';

import WebFont from 'webfontloader';
import { renderFeed } from './common/renderFeed'
import { uniqueWebFonts } from './utils/Utils'
import { WEB_LOAD_FONT_LIST } from './constants/Fonts'

import 'styles/fonts/SvgIcons.font'

const pageWebFonts = SMEditor.webFonts && SMEditor.webFonts.length > 0
    ? uniqueWebFonts(SMEditor.webFonts)
    : [];

const fontList = pageWebFonts.map( font => {
    const webFont = WEB_LOAD_FONT_LIST.find( webFont => webFont.value === font );
    return webFont && webFont.weights ? `${webFont.value}:${webFont.weights.join(",")}` : font;
});

if ( fontList.length ) {
    WebFont.load({
        google: {
            families: fontList
        },
        classes: false,
        events: false
    });
}

// Smooth scroll on clicking links
$(document).ready(function() {
    $(function() {
        $('a[href*="#"]:not([href="#"])').click(function() {
            if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    $('html, body').animate({
                        scrollTop: target.offset().top
                    }, 1000);
                    return false;
                }
            }
        });
    });
    //if there are any slideshows -> initialise them
    if($('.gallery').length) {
        $('.gallery').slick();
    }
    if($('.filmstrip-nav').length) {
        $('.filmstrip-nav').on('click', 'a', function () {
            $('#'+ $(this).attr('data-nav-for')).slick('slickGoTo', $(this).attr('id'));
        });
    }
    $('[data-nocontextmenu=true]').contextmenu(function() {
        return false;
    });

    // initialise RSS feed apps, if any
    var rssFeeds = $('.rss-feed-app');
    if (rssFeeds.length) {
        renderFeed(rssFeeds);
    }
});



// WEBPACK FOOTER //
// ./src/render.js